import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-advt-invoice-very-briefly',
  templateUrl: './advt-invoice-very-briefly.component.html',
  styleUrl: './advt-invoice-very-briefly.component.scss'
})
export class AdvtInvoiceVeryBrieflyComponent {

  startDate;
  endDate;
  today;
  issueName;
  issueDates;
  reportType;
  advtInvoiceData;
  filteredAdvtInvoiceData: any;
  isLoading = false;
  sdate: any;
  enddate: any;
  invoiceName: any;
  issuedate: any;
  advtamount: any;
  discountamt: any;
  gstcst: any;
  cgst: number;
  sgst: number;
  igst: number;
  invoice_total: any;
  totalbeforegstamount: number;
  paidamount: any;
  offRepName: any;
  repName: any;

  constructor(
    private dialogRef: MatDialogRef<AdvtInvoiceVeryBrieflyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    this.isLoading = false;
    this.today = new Date();
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.issueName = this.data['issueName'];
    this.issueDates = this.data['issueDates'];
    this.reportType = this.data['reportType'];
    this.sdate = this.data['startDate'];
    this.enddate = this.data['endDate'];
    this.invoiceName = this.data['issueName'];
    this.issuedate = this.data['issueDates'];
    this.offRepName = this.data['off_rep_name'];
    this.repName = this.data['rep_name'];

    this.getData();
  }

  getData() {
    const req: any = {
      "start_date": this.sdate,
      "end_date": this.enddate,
      "issue_name": this.invoiceName,
      "issue_date": this.issuedate,
      "rep_name": this.repName?.length ? this.repName : "",
      "off_rep_name": this.offRepName?.length ? this.offRepName : "",
    }

    // this.service.getAdvtInvoiceRegisterListBriefly(req).subscribe((res: any) => {
    //   console.log(res);
      
    //   // Initialize grand totals
    //   this.advtamount = 0;
    //   this.discountamt = 0;
    //   this.invoice_total = 0;
    //   this.cgst = 0;
    //   this.sgst = 0;
    //   this.igst = 0;
    //   this.gstcst = 0;
    //   this.totalbeforegstamount = 0;
    //   this.paidamount = 0;

    //   // Process each group and calculate rep-wise totals
    //   this.filteredAdvtInvoiceData = res.map(group => {
    //     const repTotals = {
    //       advt_amt: 0,
    //       discount: 0,
    //       beforegst_amt: 0,
    //       cgst: 0,
    //       sgst: 0,
    //       igst: 0,
    //       gst: 0,
    //       invoice_total: 0,
    //       received_amt: 0,
    //       unpaid_amount: 0
    //     };

    //     // Calculate totals for this representative
    //     for (let data1 of group.data) {
    //       const advtAmt = parseFloat(data1.advt_amt) || 0;
    //       const discountAmt = parseFloat(data1.discount) || 0;
    //       const beforegstAmt = parseFloat(data1.beforegst_amt) || 0;
    //       const invoiceTotal = parseFloat(data1.invoice_total) || 0;
    //       const cgstAmt = parseFloat(data1.cgst) || 0;
    //       const sgstAmt = parseFloat(data1.sgst) || 0;
    //       const igstAmt = parseFloat(data1.igst) || 0;
    //       const gstAmt = parseFloat(data1.gst) || 0;
    //       const paidAmt = parseFloat(data1.received_amt) || 0;
    //       const unpaidAmt = parseFloat(data1.unpaid_amount) || 0;

    //       // Add to representative totals
    //       repTotals.advt_amt += advtAmt;
    //       repTotals.discount += discountAmt;
    //       repTotals.beforegst_amt += beforegstAmt;
    //       repTotals.invoice_total += invoiceTotal;
    //       repTotals.cgst += cgstAmt;
    //       repTotals.sgst += sgstAmt;
    //       repTotals.igst += igstAmt;
    //       repTotals.gst += gstAmt;
    //       repTotals.received_amt += paidAmt;
    //       repTotals.unpaid_amount += unpaidAmt;

    //       // Add to grand totals
    //       this.advtamount += advtAmt;
    //       this.discountamt += discountAmt;
    //       this.totalbeforegstamount += beforegstAmt;
    //       this.invoice_total += invoiceTotal;
    //       this.cgst += cgstAmt;
    //       this.sgst += sgstAmt;
    //       this.igst += igstAmt;
    //       this.gstcst += gstAmt;
    //       this.paidamount += paidAmt;
    //     }

    //     // Round representative totals to 2 decimal places
    //     repTotals.advt_amt = parseFloat(repTotals.advt_amt.toFixed(2));
    //     repTotals.discount = parseFloat(repTotals.discount.toFixed(2));
    //     repTotals.beforegst_amt = parseFloat(repTotals.beforegst_amt.toFixed(2));
    //     repTotals.invoice_total = parseFloat(repTotals.invoice_total.toFixed(2));
    //     repTotals.cgst = parseFloat(repTotals.cgst.toFixed(2));
    //     repTotals.sgst = parseFloat(repTotals.sgst.toFixed(2));
    //     repTotals.igst = parseFloat(repTotals.igst.toFixed(2));
    //     repTotals.gst = parseFloat(repTotals.gst.toFixed(2));
    //     repTotals.received_amt = parseFloat(repTotals.received_amt.toFixed(2));
    //     repTotals.unpaid_amount = parseFloat(repTotals.unpaid_amount.toFixed(2));

    //     return {
    //       off_rep_name: group.off_rep_name,
    //       rep_name: group.rep_name,
    //       rep_totals: repTotals,
    //       data: group.data // Keep original data if needed for reference
    //     };
    //   });

    //   // Round grand totals to 2 decimal places
    //   this.advtamount = parseFloat(this.advtamount.toFixed(2));
    //   this.discountamt = parseFloat(this.discountamt.toFixed(2));
    //   this.invoice_total = parseFloat(this.invoice_total.toFixed(2));
    //   this.cgst = parseFloat(this.cgst.toFixed(2));
    //   this.sgst = parseFloat(this.sgst.toFixed(2));
    //   this.igst = parseFloat(this.igst.toFixed(2));
    //   this.gstcst = parseFloat(this.gstcst.toFixed(2));
    //   this.totalbeforegstamount = parseFloat(this.totalbeforegstamount.toFixed(2));
    //   this.paidamount = parseFloat(this.paidamount.toFixed(2));

    //   console.log('Filtered data with rep totals:', this.filteredAdvtInvoiceData);
    //   console.log('Grand totals:', {
    //     advtamount: this.advtamount,
    //     invoice_total: this.invoice_total,
    //     paidamount: this.paidamount
    //   });
    // });
  
//     this.service.getAdvtInvoiceRegisterListBriefly(req).subscribe((res: any) => {
//   console.log('API Response:', res);
//   this.filteredAdvtInvoiceData = res;
  
//   // Initialize grand totals
//   this.advtamount = 0;
//   this.discountamt = 0;
//   this.invoice_total = 0;
//   this.cgst = 0;
//   this.sgst = 0;
//   this.igst = 0;
//   this.gstcst = 0;
//   this.totalbeforegstamount = 0;
//   this.paidamount = 0;

//   // Iterate through the office representative groups
//   for (let officeGroup of this.filteredAdvtInvoiceData) {
    
//     // Iterate through representatives under this office representative
//     for (let repGroup of officeGroup.representatives) {
//       // Initialize representative-wise totals
//       repGroup.rep_advt_amt = 0;
//       repGroup.rep_discount = 0;
//       repGroup.rep_beforegst_amt = 0;
//       repGroup.rep_cgst = 0;
//       repGroup.rep_sgst = 0;
//       repGroup.rep_igst = 0;
//       repGroup.rep_gst = 0;
//       repGroup.rep_invoice_total = 0;
//       repGroup.rep_paid_amt = 0;
//       repGroup.rep_unpaid_amt = 0;

//       // Iterate through the data array in each representative group
//       for (let data1 of repGroup.data) {
//         // Parse values to float with fallback to 0
//         const advtAmt = parseFloat(data1.advt_amt) || 0;
//         const discountAmt = parseFloat(data1.discount) || 0;
//         const beforegstAmt = parseFloat(data1.beforegst_amt) || 0;
//         const invoiceTotal = parseFloat(data1.invoice_total) || 0;
//         const cgstAmt = parseFloat(data1.cgst) || 0;
//         const sgstAmt = parseFloat(data1.sgst) || 0;
//         const igstAmt = parseFloat(data1.igst) || 0;
//         const gstAmt = parseFloat(data1.gst) || 0;
//         const paidAmt = parseFloat(data1.received_amt) || 0;
//         const unpaidAmt = parseFloat(data1.unpaid_amount) || 0;
        
//         // Add to representative totals
//         repGroup.rep_advt_amt += advtAmt;
//         repGroup.rep_discount += discountAmt;
//         repGroup.rep_beforegst_amt += beforegstAmt;
//         repGroup.rep_cgst += cgstAmt;
//         repGroup.rep_sgst += sgstAmt;
//         repGroup.rep_igst += igstAmt;
//         repGroup.rep_gst += gstAmt;
//         repGroup.rep_invoice_total += invoiceTotal;
//         repGroup.rep_paid_amt += paidAmt;
//         repGroup.rep_unpaid_amt += unpaidAmt;

//         // Add to grand totals
//         this.advtamount += advtAmt;
//         this.discountamt += discountAmt;
//         this.totalbeforegstamount += beforegstAmt;
//         this.invoice_total += invoiceTotal;
//         this.cgst += cgstAmt;
//         this.sgst += sgstAmt;
//         this.igst += igstAmt;
//         this.gstcst += gstAmt;
//         this.paidamount += paidAmt;
//       }

//       // Round representative totals to 2 decimal places
//       repGroup.rep_advt_amt = parseFloat(repGroup.rep_advt_amt.toFixed(2));
//       repGroup.rep_discount = parseFloat(repGroup.rep_discount.toFixed(2));
//       repGroup.rep_beforegst_amt = parseFloat(repGroup.rep_beforegst_amt.toFixed(2));
//       repGroup.rep_cgst = parseFloat(repGroup.rep_cgst.toFixed(2));
//       repGroup.rep_sgst = parseFloat(repGroup.rep_sgst.toFixed(2));
//       repGroup.rep_igst = parseFloat(repGroup.rep_igst.toFixed(2));
//       repGroup.rep_gst = parseFloat(repGroup.rep_gst.toFixed(2));
//       repGroup.rep_invoice_total = parseFloat(repGroup.rep_invoice_total.toFixed(2));
//       repGroup.rep_paid_amt = parseFloat(repGroup.rep_paid_amt.toFixed(2));
//       repGroup.rep_unpaid_amt = parseFloat(repGroup.rep_unpaid_amt.toFixed(2));
//     }
//   }
  
//   // Round grand totals to 2 decimal places
//   this.advtamount = parseFloat(this.advtamount.toFixed(2));
//   this.discountamt = parseFloat(this.discountamt.toFixed(2));
//   this.invoice_total = parseFloat(this.invoice_total.toFixed(2));
//   this.cgst = parseFloat(this.cgst.toFixed(2));
//   this.sgst = parseFloat(this.sgst.toFixed(2));
//   this.igst = parseFloat(this.igst.toFixed(2));
//   this.gstcst = parseFloat(this.gstcst.toFixed(2));
//   this.totalbeforegstamount = parseFloat(this.totalbeforegstamount.toFixed(2));
//   this.paidamount = parseFloat(this.paidamount.toFixed(2));
  
//   console.log('Processed data:', this.filteredAdvtInvoiceData);
//   console.log('Grand totals:', {
//     advtamount: this.advtamount,
//     invoice_total: this.invoice_total,
//     paidamount: this.paidamount
//   });
// });
  
this.service.getAdvtInvoiceRegisterListBriefly(req).subscribe((res: any) => {
  console.log('API Response:', res);
  this.filteredAdvtInvoiceData = res;
  
  // Initialize grand totals
  this.advtamount = 0;
  this.discountamt = 0;
  this.invoice_total = 0;
  this.cgst = 0;
  this.sgst = 0;
  this.igst = 0;
  this.gstcst = 0;
  this.totalbeforegstamount = 0;
  this.paidamount = 0;

  // Iterate through the office representative groups
  for (let officeGroup of this.filteredAdvtInvoiceData) {
    // Initialize office representative totals
    officeGroup.off_rep_advt_amt = 0;
    officeGroup.off_rep_discount = 0;
    officeGroup.off_rep_beforegst_amt = 0;
    officeGroup.off_rep_cgst = 0;
    officeGroup.off_rep_sgst = 0;
    officeGroup.off_rep_igst = 0;
    officeGroup.off_rep_gst = 0;
    officeGroup.off_rep_invoice_total = 0;
    officeGroup.off_rep_paid_amt = 0;
    officeGroup.off_rep_unpaid_amt = 0;
    
    // Iterate through representatives under this office representative
    for (let repGroup of officeGroup.representatives) {
      // Initialize representative-wise totals
      repGroup.rep_advt_amt = 0;
      repGroup.rep_discount = 0;
      repGroup.rep_beforegst_amt = 0;
      repGroup.rep_cgst = 0;
      repGroup.rep_sgst = 0;
      repGroup.rep_igst = 0;
      repGroup.rep_gst = 0;
      repGroup.rep_invoice_total = 0;
      repGroup.rep_paid_amt = 0;
      repGroup.rep_unpaid_amt = 0;

      // Iterate through the data array in each representative group
      for (let data1 of repGroup.data) {
        // Parse values to float with fallback to 0
        const advtAmt = parseFloat(data1.advt_amt) || 0;
        const discountAmt = parseFloat(data1.discount) || 0;
        const beforegstAmt = parseFloat(data1.beforegst_amt) || 0;
        const invoiceTotal = parseFloat(data1.invoice_total) || 0;
        const cgstAmt = parseFloat(data1.cgst) || 0;
        const sgstAmt = parseFloat(data1.sgst) || 0;
        const igstAmt = parseFloat(data1.igst) || 0;
        const gstAmt = parseFloat(data1.gst) || 0;
        const paidAmt = parseFloat(data1.received_amt) || 0;
        const unpaidAmt = parseFloat(data1.unpaid_amount) || 0;
        
        // Add to representative totals
        repGroup.rep_advt_amt += advtAmt;
        repGroup.rep_discount += discountAmt;
        repGroup.rep_beforegst_amt += beforegstAmt;
        repGroup.rep_cgst += cgstAmt;
        repGroup.rep_sgst += sgstAmt;
        repGroup.rep_igst += igstAmt;
        repGroup.rep_gst += gstAmt;
        repGroup.rep_invoice_total += invoiceTotal;
        repGroup.rep_paid_amt += paidAmt;
        repGroup.rep_unpaid_amt += unpaidAmt;

        // Add to grand totals
        this.advtamount += advtAmt;
        this.discountamt += discountAmt;
        this.totalbeforegstamount += beforegstAmt;
        this.invoice_total += invoiceTotal;
        this.cgst += cgstAmt;
        this.sgst += sgstAmt;
        this.igst += igstAmt;
        this.gstcst += gstAmt;
        this.paidamount += paidAmt;
      }

      // Round representative totals to 2 decimal places
      repGroup.rep_advt_amt = parseFloat(repGroup.rep_advt_amt.toFixed(2));
      repGroup.rep_discount = parseFloat(repGroup.rep_discount.toFixed(2));
      repGroup.rep_beforegst_amt = parseFloat(repGroup.rep_beforegst_amt.toFixed(2));
      repGroup.rep_cgst = parseFloat(repGroup.rep_cgst.toFixed(2));
      repGroup.rep_sgst = parseFloat(repGroup.rep_sgst.toFixed(2));
      repGroup.rep_igst = parseFloat(repGroup.rep_igst.toFixed(2));
      repGroup.rep_gst = parseFloat(repGroup.rep_gst.toFixed(2));
      repGroup.rep_invoice_total = parseFloat(repGroup.rep_invoice_total.toFixed(2));
      repGroup.rep_paid_amt = parseFloat(repGroup.rep_paid_amt.toFixed(2));
      repGroup.rep_unpaid_amt = parseFloat(repGroup.rep_unpaid_amt.toFixed(2));

      // Add representative totals to office representative totals
      officeGroup.off_rep_advt_amt += repGroup.rep_advt_amt;
      officeGroup.off_rep_discount += repGroup.rep_discount;
      officeGroup.off_rep_beforegst_amt += repGroup.rep_beforegst_amt;
      officeGroup.off_rep_cgst += repGroup.rep_cgst;
      officeGroup.off_rep_sgst += repGroup.rep_sgst;
      officeGroup.off_rep_igst += repGroup.rep_igst;
      officeGroup.off_rep_gst += repGroup.rep_gst;
      officeGroup.off_rep_invoice_total += repGroup.rep_invoice_total;
      officeGroup.off_rep_paid_amt += repGroup.rep_paid_amt;
      officeGroup.off_rep_unpaid_amt += repGroup.rep_unpaid_amt;
    }

    // Round office representative totals to 2 decimal places
    officeGroup.off_rep_advt_amt = parseFloat(officeGroup.off_rep_advt_amt.toFixed(2));
    officeGroup.off_rep_discount = parseFloat(officeGroup.off_rep_discount.toFixed(2));
    officeGroup.off_rep_beforegst_amt = parseFloat(officeGroup.off_rep_beforegst_amt.toFixed(2));
    officeGroup.off_rep_cgst = parseFloat(officeGroup.off_rep_cgst.toFixed(2));
    officeGroup.off_rep_sgst = parseFloat(officeGroup.off_rep_sgst.toFixed(2));
    officeGroup.off_rep_igst = parseFloat(officeGroup.off_rep_igst.toFixed(2));
    officeGroup.off_rep_gst = parseFloat(officeGroup.off_rep_gst.toFixed(2));
    officeGroup.off_rep_invoice_total = parseFloat(officeGroup.off_rep_invoice_total.toFixed(2));
    officeGroup.off_rep_paid_amt = parseFloat(officeGroup.off_rep_paid_amt.toFixed(2));
    officeGroup.off_rep_unpaid_amt = parseFloat(officeGroup.off_rep_unpaid_amt.toFixed(2));
  }
  
  // Round grand totals to 2 decimal places
  this.advtamount = parseFloat(this.advtamount.toFixed(2));
  this.discountamt = parseFloat(this.discountamt.toFixed(2));
  this.invoice_total = parseFloat(this.invoice_total.toFixed(2));
  this.cgst = parseFloat(this.cgst.toFixed(2));
  this.sgst = parseFloat(this.sgst.toFixed(2));
  this.igst = parseFloat(this.igst.toFixed(2));
  this.gstcst = parseFloat(this.gstcst.toFixed(2));
  this.totalbeforegstamount = parseFloat(this.totalbeforegstamount.toFixed(2));
  this.paidamount = parseFloat(this.paidamount.toFixed(2));
  
  console.log('Processed data:', this.filteredAdvtInvoiceData);
  console.log('Grand totals:', {
    advtamount: this.advtamount,
    invoice_total: this.invoice_total,
    paidamount: this.paidamount
  });
});


  }

  exportExcel(fileName) {
    let element = document.getElementById('print-section1');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  show = false;

  printPage() {
    this.show = true;
    const printSection = document.getElementById('print-section1');
    if (!printSection) {
      console.error("Print section not found!");
      return;
    }

    const printContent = printSection.innerHTML;
    const screenWidth = window.screen.availWidth;
    const windowWidth = 1000;
    const leftPosition = screenWidth - windowWidth - 50;

    const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Report</title>
            <style>
              @media print {
                @page {
                  size: A3 landscape;
                  margin: 5mm;
                }
                body {
                  font-family: Arial, sans-serif;
                  margin: 0;
                  padding: 0;
                  font-size: 16px !important;
                }
                table {
                  width: 100% !important;
                  border-collapse: collapse;
                  border: 2px solid black !important;
                }
                th, td {
                  padding: 4px 6px !important;
                  border: 1px solid black !important;
                  font-size: 16px;
                }
                th {
                  background-color: #f2f2f2;
                  font-weight: bold;
                }
                .noPrint { display: none !important; }
              }
            </style>
          </head>
          <body>
            ${printContent}
            <script>
              window.onload = function() {
                setTimeout(() => {
                  window.print();
                  setTimeout(() => { window.close(); }, 500);
                }, 200);
              };
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

  closeexp(): void {
    this.dialogRef.close();
  }
}